import { supabase } from "@/integrations/supabase/client";

export interface TtsParams {
  voiceId: string;
  text: string;
  outputFormat?: string; // mp3_44100_128
  modelId?: string; // eleven_multilingual_v2
  languageCode?: string | null;
  enableLogging?: boolean;
}

export class TextToSpeechService {
  static async synthesize({
    voiceId,
    text,
    outputFormat = "mp3_44100_128",
    modelId = "eleven_multilingual_v2",
    languageCode = null,
    enableLogging = true,
  }: TtsParams): Promise<string> {
    const { data, error } = await supabase.functions.invoke("elevenlabs", {
      body: {
        resource: "tts",
        action: "generate",
        params: { voiceId, text, outputFormat, modelId, languageCode, enableLogging },
      },
    });

    console.log("TTS generation response:", { data, error });

    if (error) {
      throw new Error(error.message || "TTS synthesis failed");
    }

    return `data:${data?.mimeType || "audio/mpeg"};base64,${data.audioBase64}`;
  }
}
